import { useState, useEffect, useRef } from 'preact/hooks'
import { matchMedia } from '../helpers/match-media'
import { useCustomMedia } from './useCustomMedia'

export type Matches = {
  [key: string]: boolean
}

export const useMediaQueries = (queries: string[]): Matches => {
  const customMedia = useCustomMedia()
  const firstRender = useRef(true)
  const [matches, setMatches] = useState<Matches>(() => {
    return queries.reduce<Matches>((result, q) => {
      result[q] = matchMedia(q, customMedia).matches
      return result
    }, {})
  })

  useEffect(() => {
    const mediaQueryLists = queries.map(q => matchMedia(q, customMedia))
    let mounted = true
    const handleChange = () => {
      if (!mounted) {
        return
      }

      const newMatches = mediaQueryLists.reduce<Matches>((result, list, idx) => {
        result[queries[idx]] = list.matches
        return result
      }, {})

      setMatches(newMatches)
    }

    mediaQueryLists.forEach(mql => mql.addEventListener('change', handleChange))

    if (!firstRender.current) {
      handleChange()
    } else {
      firstRender.current = false
    }

    return () => {
      mounted = false
      mediaQueryLists.forEach(mql => mql.removeEventListener('change', handleChange))
    }
  }, [queries, customMedia])

  return matches
}
